<template>
    
</template>

<script>
    export default {
        name: "Kinesitherapies"
    }
</script>

<style scoped>

</style>